// Reviewer-facing wording for the comment → Slack mirror, shared by every review surface so the
// three of them cannot drift apart.
//
// The mirror is best-effort by design: `POST /queue/items/:id/comment` persists the comment and the
// audit event first, then attempts `chat.postMessage`, and a Slack outage never fails the request
// (see `SlackNotifierService`). Session 05 recorded the consequence of describing that outcome
// badly — "Comment saved; Slack mirror unavailable." was rendered in the same success green as a
// delivered comment, so the reviewer had no signal that the AD channel was never notified (S5-T7).
// Until a durable outbox exists, the copy must state both halves plainly: the comment IS saved, and
// Slack did NOT get it.

export type CommentDeliveryTone = 'success' | 'warning';

export interface CommentStatus {
  tone: CommentDeliveryTone;
  message: string;
}

export function describeCommentDelivery(postedToSlack: boolean): CommentStatus {
  return postedToSlack
    ? { tone: 'success', message: 'Comment posted to Slack.' }
    : {
        tone: 'warning',
        message: 'Saved in the author tool — not delivered to Slack. Notify the channel manually.',
      };
}

/** Same wording, prefixed with the item it belongs to (queue dashboard banner). */
export function describeCommentDeliveryFor(workItemId: string, postedToSlack: boolean): CommentStatus {
  return postedToSlack
    ? { tone: 'success', message: `Comment on ${workItemId} posted to Slack.` }
    : {
        tone: 'warning',
        message: `Comment on ${workItemId} saved in the author tool — not delivered to Slack. Notify the channel manually.`,
      };
}

export const COMMENT_STATUS_STYLES: Record<CommentDeliveryTone, string> = {
  success: 'text-emerald-700',
  warning: 'text-amber-700',
};
